import React from "react";
import { motion } from "framer-motion";
import Where1 from "../assets/images/Where1.png";
import Hero from "../assets/images/Hero.png";

const Join = () => {
  return (
    <section className="bg-white py-20 lg:py-32 px-4 sm:px-6 font-avant overflow-visible">
      <div className="container mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="relative bg-bgcolor rounded-[2.5rem] lg:rounded-[4rem] min-h-[500px] lg:min-h-[550px] flex flex-col lg:flex-row items-center shadow-[0_30px_100px_rgba(0,0,0,0.1)] overflow-visible"
        >
          {/* Left Content */}
          <div className="w-full lg:w-[60%] p-10 lg:p-20 z-20 text-center lg:text-left">
            <motion.h2
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="text-white text-4xl md:text-6xl font-bold leading-[1.1] mb-6 tracking-tight"
            >
              Join the Fun – Download <br className="hidden lg:block" />
              MyBindle Now!
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-white/90 text-lg md:text-xl max-w-md mb-10 leading-relaxed font-medium"
            >
              Your Social Network, Your Way. Download MyBindle Now and Be a Part
              of a Community That's Always Evolving!
            </motion.p>

            {/* Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="flex flex-wrap justify-center lg:justify-start gap-5"
            >
              {/* App Store */}
              <a
                href="#"
                className="bg-bggraycolor text-black flex items-center gap-3 px-7 py-3.5 rounded-2xl hover:scale-105 transition-all shadow-xl active:scale-95"
              >
                <svg
                  className="w-8 h-8"
                  viewBox="0 0 384 512"
                  fill="currentColor"
                >
                  <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 21.8-88.5 21.8-11.4 0-53.8-24.3-89.8-23.6-47.5 1.2-105 32.7-105 116.3 0 54.3 22.1 123.6 54.4 171.1 23.3 34.1 49.3 64.9 83.4 64.9 33 0 45.4-20.3 85-20.3 39.3 0 51.5 20.3 85.3 20.3 34.6 0 62.4-32.9 85.3-64.8 26.6-38.3 37.5-75.4 37.8-77.3-.8-.3-73.1-28.2-73.3-100.1zM290.1 82.7c21.8-26.6 22.5-62.1 12.3-90.7-32 3-64.4 22.8-78.7 45.9-15.3 24.3-19.8 55-11.2 81.3 31.8 1.8 62.1-17.6 77.6-36.5z" />
                </svg>
                <div className="text-left leading-none">
                  <p className="text-[11px] uppercase font-bold mb-1">
                    Download on the
                  </p>
                  <p className="text-xl font-bold">App Store</p>
                </div>
              </a>

              {/* Google Play */}
              <a
                href="#"
                className="bg-white text-black flex items-center gap-3 px-7 py-3.5 rounded-2xl hover:scale-105 transition-all shadow-xl active:scale-95"
              >
                <svg className="w-8 h-8" viewBox="0 0 512 512">
                  <path
                    fill="#00a1f1"
                    d="M25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0C34 6.8 25.3 19.2 25.3 35.3z"
                  />
                  <path
                    fill="#ff3b30"
                    d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1z"
                  />
                  <path
                    fill="#fdb900"
                    d="M472.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-10.3 18-27.1-1.2-36.3z"
                  />
                  <path
                    fill="#34a853"
                    d="M385.4 337.8L104.6 499l280.8-161.2-60.1-60.1z"
                  />
                </svg>
                <div className="text-left leading-none">
                  <p className="text-[11px] uppercase font-bold mb-1">
                    Get it on
                  </p>
                  <p className="text-xl font-bold">Google Play</p>
                </div>
              </a>
            </motion.div>
          </div>

          {/* Right Side Images */}
          <div className="w-full lg:w-[40%] relative h-[400px] lg:h-[500px] flex items-end justify-end z-20 overflow-hidden">
            {/* Back Image */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
              className="absolute bottom-0 left-0"
            >
              <img
                src={Where1}
                className="w-[180px] md:w-[280px] lg:w-[320px] rounded-t-[2.5rem]"
                alt="Back"
              />
            </motion.div>

            {/* Front Image */}
            <motion.div
              initial={{ opacity: 0, y: 70 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.6, ease: "easeOut" }}
              className="absolute bottom-0 right-0"
            >
              <img
                src={Hero}
                className="w-[230px] md:w-[330px] lg:w-[420px]  "
                alt="Front"
              />
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Join;
